<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-6 w-full min-w-0">

    <div class="col-span-2 md:col-span-6 flex flex-col w-full bg-card shadow rounded-2xl p-4">

        <div class="flex items-start justify-between">
            <div class="text-xl font-medium tracking-tight leading-6 truncate">Val. media premoney/giorno
            </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden"
                    [batch]="'AI/CYBERSECURITY'"
                    [color]="'rgb(220, 38, 38)'"

                    [data]="appForPremoney?.batchDetail?.ai"

                    [style.background-color]="'rgba(220, 38, 38, 0.2)'"

            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'AEROSPACE'"
                    [color]="'rgb(37, 99, 235)'"
                    [style.background-color]="'rgba(37, 99, 235, 0.2)'"
                    [data]="appForPremoney?.batchDetail?.aerospace"
            ></app-val-premoney-for-day-batch-card>

        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->
            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'CLIMATE TECH'"
                    [color]="'rgb(13, 148, 136)'"
                    [style.background-color]="'rgba(13, 148, 136, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.climate"
            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'ADV. MANUFACTURING'"
                    [color]="'rgb(22, 163, 74)'"
                    [style.background-color]="'rgba(22, 163, 74, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.adMan"
            ></app-val-premoney-for-day-batch-card>


        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
            <!-- Weekly expenses -->


            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'MEDTECH/LIFE SCIENCE'"
                    [color]="'rgb(217, 119, 6)'"
                    [style.background-color]="'rgba(217, 119, 6, 0.2)'"

                    [data]="appForPremoney?.batchDetail?.biotech"
            ></app-val-premoney-for-day-batch-card>

            <app-val-premoney-for-day-batch-card
                    class="flex flex-col flex-auto p-6  shadow rounded-2xl overflow-hidden"
                    [batch]="'QUANTUM TECHNOLOGIES'"
                    [color]="'rgb(71,85,105)'"
                    [style.background-color]="'rgba(71,85,105, 0.2)'"
                    [data]="appForPremoney?.batchDetail?.quantum"
            ></app-val-premoney-for-day-batch-card>
        </div>

    </div>

    <app-val-premoney-day-area-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-0"
            [appForPremoney]="appForPremoney"
    >
    </app-val-premoney-day-area-chart>


    <app-app-batch-funding-need-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [fundingNeedBarData]="fundingNeedBarData"
    >

    </app-app-batch-funding-need-bar-chart>


    <app-val-premoney-batch-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForPremoney]="appForPremoney">

    </app-val-premoney-batch-bar-chart>


</div>
